<style>
@import '../../custom/css/lista-dicas.css';
</style>

<template>
  <div id="lista-cidades" class="lista-dicas">
    <h1 class="title text-uppercase font-weight-bold">Lista Cidades</h1>
    <hr class="linha-amarela" />
    <table class="table">
      <thead class="letter-orange">
        <tr>
          <th>Nome</th>
          <th>Estado</th>
          <th>Status</th>
          <th>Ações</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="(city, index) in getCities" :key="index">
          <td>{{ city.nome }}</td>
          <td>{{ city.estado }}</td>
          <td>{{ city.status }}</td>
          <td class="text-rigth">
            <b-button
              variant="primary"
              @click="editarCidade(city.id)"
              class="mx-1"
            >
              <i class="fas fa-edit"></i>
            </b-button>
            <b-button variant="warning" @click="verCidade(city.id)">
              <i class="fas fa-eye"></i>
            </b-button>
            <b-button
              variant="success"
              class="mx-1"
              :title="
                city.status === CityStatus.PUBLIC
                  ? 'Deixar privado'
                  : 'Deixar público'
              "
              @click="toggle(city.id)"
            >
              <i class="fas fa-exchange-alt"></i>
            </b-button>
            <b-button variant="danger" @click="excluirCidade(city.id)">
              <i class="fas fa-trash-alt"></i>
            </b-button>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import CityStatus from '../../enums/CityStatus';
import makeToast from '../../mixins/makeToast';

export default {
  name: 'lista-cidades',
  mixins: [makeToast],
  data() {
    return {
      CityStatus,
    };
  },
  computed: {
    ...mapGetters([
      'getTipoNotification',
      'getNotification',
      'getLoaderAction',
    ]),
    ...mapGetters('admin', ['getCities']),
  },
  created() {
    this.$store.dispatch('admin/getCities');
  },
  methods: {
    ...mapActions('admin', ['toggleCityStatus']),
    aviso(texto, tipo) {
      this.$bvToast.toast(texto, {
        title: 'Aviso',
        variant: tipo,
        autoHideDelay: 5000,
        appendToast: true,
      });
    },
    editarCidade(id) {
      this.$router.push({
        name: 'administrador-editar-cidade',
        params: { id },
      });
    },
    verCidade(id) {
      this.$router.push({
        name: 'administrador-ver-cidade',
        params: { id },
      });
    },
    async excluirCidade(id) {
      const self = this;
      if (confirm('Deseja deletar realmente esse cidade?')) {
        self.$store.dispatch('startLoader');
        await this.$store
          .dispatch('deleteCidade', id)
          .then((data) => {
            self.aviso('Deletado com sucesso', 'success');
            setTimeout(() => {
              self.$store.dispatch('loadCidades').then(() => {
                setTimeout(() => {
                  self.$store.dispatch('endLoader');
                }, 1000);
              });
            }, 100);
          })
          .catch(() => {
            self.$store.dispatch('endLoader');
            self.aviso(
              'Houve um problema para deletar, tente novamente em 5 minutos!',
              'danger'
            );
          });
      }
    },
    toggle(cityId) {
      this.$store.dispatch('startLoader');

      this.toggleCityStatus(cityId)
        .then((response) => {
          this.makeToast('Sucesso!', response.data.message);
        })
        .then(() => {
          this.$store.dispatch('startLoader');
          this.$store
            .dispatch('admin/getCities')
            .finally(() => this.$store.dispatch('endLoader'));
        })
        .catch((error) => {
          this.makeToast('Oopss!', error.response.data.message, 'danger');
        })
        .finally(() => this.$store.dispatch('endLoader'));
    },
  },
};
</script>
